import _stubFalse from "lodash/stubFalse";
import _noop from "lodash/noop";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _fillInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/fill";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";

/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import YearAndMonthFoundation from '@douyinfe/semi-foundation/lib/es/datePicker/yearAndMonthFoundation';
import BaseComponent from '../_base/baseComponent';
import ScrollList from '../scrollList/index';
import ScrollItem from '../scrollList/scrollItem';
import { getYears } from '@douyinfe/semi-foundation/lib/es/datePicker/_utils/index';
import isNullOrUndefined from '@douyinfe/semi-foundation/lib/es/utils/isNullOrUndefined';
import IconButton from '../iconButton';
import { IconChevronLeft } from '@douyinfe/semi-icons';
import { BASE_CLASS_PREFIX } from '@douyinfe/semi-foundation/lib/es/base/constants';
import { setYear, setMonth } from 'date-fns';
import { strings } from '@douyinfe/semi-foundation/lib/es/datePicker/constants';
const prefixCls = "".concat(BASE_CLASS_PREFIX, "-datepicker");

class YearAndMonth extends BaseComponent {
  constructor(props) {
    var _context, _context2, _context3;

    super(props);

    this.selectYear = item => {
      this.foundation.selectYear(item);
    };

    this.selectMonth = item => {
      this.foundation.selectMonth(item);
    };

    this.reselect = () => {
      const refKeys = ['yearRef', 'monthRef'];

      _forEachInstanceProperty(refKeys).call(refKeys, key => {
        const ref = this[key];

        if (ref && ref.current && ref.current.scrollToIndex) {
          ref.current.scrollToIndex();
        }
      });
    };

    this.backToMain = e => {
      e.nativeEvent.stopImmediatePropagation();
      this.foundation.backToMain();
    };

    const now = new Date();
    let {
      currentYear,
      currentMonth
    } = props;
    currentYear = currentYear || now.getFullYear();
    currentMonth = currentMonth || now.getMonth() + 1;
    this.state = {
      years: _mapInstanceProperty(_context = getYears()).call(_context, year => ({
        value: year,
        year
      })),
      months: _mapInstanceProperty(_context2 = _fillInstanceProperty(_context3 = Array(12)).call(_context3, 0)).call(_context2, (v, idx) => ({
        value: idx + 1,
        month: idx + 1
      })),
      currentYear,
      currentMonth
    };
    this.yearRef = /*#__PURE__*/React.createRef();
    this.monthRef = /*#__PURE__*/React.createRef();
    this.foundation = new YearAndMonthFoundation(this.adapter);
  }

  get adapter() {
    return _Object$assign(_Object$assign({}, super.adapter), {
      // updateYears: years => this.setState({ years }),
      // updateMonths: months => this.setState({ months }),
      setCurrentYear: currentYear => this.setState({
        currentYear
      }),
      setCurrentMonth: currentMonth => this.setState({
        currentMonth
      }),
      notifySelectYear: year => this.props.onSelect({
        currentMonth: this.state.currentMonth,
        currentYear: year
      }),
      notifySelectMonth: month => this.props.onSelect({
        currentYear: this.state.currentYear,
        currentMonth: month
      }),
      notifyBackToMain: () => this.props.onBackToMain()
    });
  }

  static getDerivedStateFromProps(props, state) {
    const willUpdateStates = {};
    const now = new Date();

    if (!isNullOrUndefined(props.currentMonth) && props.currentMonth !== state.currentMonth && props.currentMonth !== 0) {
      willUpdateStates.currentMonth = props.currentMonth || now.getMonth() + 1;
    }

    if (isNullOrUndefined(props.currentYear) && props.currentYear !== state.currentYear && props.currentYear !== 0) {
      willUpdateStates.currentYear = props.currentYear || now.getFullYear();
    }

    return willUpdateStates;
  }

  renderColYear() {
    const {
      years,
      currentYear,
      currentMonth
    } = this.state;
    const {
      disabledDate,
      localeCode,
      yearCycled
    } = this.props;
    const currentDate = setMonth(_Date$now(), currentMonth - 1);

    const list = _mapInstanceProperty(years).call(years, _ref => {
      let {
        value,
        year
      } = _ref;
      return {
        year,
        value,
        disabled: disabledDate(setYear(currentDate, year))
      };
    });

    let transform = val => val;

    if (localeCode === 'zh-CN' || localeCode === 'zh-TW') {
      // Only Chinese needs to add [year] after the selected year
      transform = val => "".concat(val, "\u5E74");
    }

    return /*#__PURE__*/React.createElement(ScrollItem, {
      ref: this.yearRef,
      cycled: yearCycled,
      list: list,
      transform: transform,
      selectedIndex: _findIndexInstanceProperty(years).call(years, item => item.value === currentYear),
      type: "year",
      onSelect: this.selectYear
    });
  }

  renderColMonth() {
    const {
      months,
      currentMonth,
      currentYear
    } = this.state;
    const {
      locale,
      localeCode,
      monthCycled,
      disabledDate
    } = this.props;

    let transform = val => val;

    const currentDate = setYear(_Date$now(), currentYear);

    if (localeCode === 'zh-CN' || localeCode === 'zh-TW') {
      // Only Chinese needs to add [month] after the selected month
      transform = val => "".concat(val, "\u6708");
    } // i18n


    const list = _mapInstanceProperty(months).call(months, _ref2 => {
      let {
        value,
        month
      } = _ref2;
      return {
        month,
        disabled: disabledDate(setMonth(currentDate, month - 1)),
        value: locale.fullMonths[value] // Actual rendered text

      };
    });

    const selectedIndex = _findIndexInstanceProperty(list).call(list, item => item.month === currentMonth);

    return /*#__PURE__*/React.createElement(ScrollItem, {
      ref: this.monthRef,
      cycled: monthCycled,
      list: list,
      transform: transform,
      selectedIndex: selectedIndex,
      type: "month",
      onSelect: this.selectMonth
    });
  }

  render() {
    const {
      locale,
      noBackBtn,
      density,
      presetPosition,
      renderQuickControls,
      renderDateInput
    } = this.props;
    const prefix = "".concat(prefixCls, "-yearmonth-header"); // i18n

    const selectDateText = locale.selectDate;
    const iconSize = density === 'compact' ? 'default' : 'large';
    const buttonSize = density === 'compact' ? 'small' : 'default';
    return /*#__PURE__*/React.createElement(React.Fragment, null, noBackBtn ? null : /*#__PURE__*/React.createElement("div", {
      className: prefix
    }, /*#__PURE__*/React.createElement(IconButton, {
      noHorizontalPadding: false,
      icon: /*#__PURE__*/React.createElement(IconChevronLeft, {
        "aria-hidden": true,
        size: iconSize
      }),
      size: buttonSize,
      onClick: this.backToMain
    }, /*#__PURE__*/React.createElement("span", null, selectDateText))), presetPosition ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, presetPosition === "left" && renderQuickControls, /*#__PURE__*/React.createElement("div", null, renderDateInput, /*#__PURE__*/React.createElement(ScrollList, null, this.renderColYear(), this.renderColMonth())), presetPosition === "right" && renderQuickControls) : /*#__PURE__*/React.createElement(React.Fragment, null, renderDateInput, /*#__PURE__*/React.createElement(ScrollList, null, this.renderColYear(), this.renderColMonth())));
  }

}

YearAndMonth.propTypes = {
  currentYear: PropTypes.number,
  currentMonth: PropTypes.number,
  onSelect: PropTypes.func,
  locale: PropTypes.object,
  localeCode: PropTypes.string,
  monthCycled: PropTypes.bool,
  yearCycled: PropTypes.bool,
  noBackBtn: PropTypes.bool,
  disabledDate: PropTypes.func,
  density: PropTypes.string,
  presetPosition: PropTypes.oneOf(strings.PRESET_POSITION_SET),
  renderQuickControls: PropTypes.node,
  renderDateInput: PropTypes.node
};
YearAndMonth.defaultProps = {
  disabledDate: _stubFalse,
  monthCycled: false,
  yearCycled: false,
  noBackBtn: false,
  onSelect: _noop
};
export default YearAndMonth;